export const thematix = [
  {
    "title": "Mentalno zdravlje u različitim životnim razdobljima i kontekstima",
    "bullets": {
      "a": "Mentalno zdravlje djece, mladih, odraslih i starijih osoba",
      "b": "Razvojne krize i prijelazna razdoblja",
      "c": "Otpornost, prilagodba i čimbenici ranjivosti",
      "d": "Mentalno zdravlje u kontekstu obitelji i bliskih odnosa",
      "e": "Mentalno zdravlje u radnom i profesionalnom okruženju",
      "f": "Mentalno zdravlje u kriznim, ratnim i postkriznim situacijama",
      "g": "Mentalno zdravlje djece s teškoćama u razvoju i osoba s invaliditetom"
    }
  },
  {
    "title": "Klinička i zdravstvena psihologija: procjena, dijagnostika i tretman",
    "bullets": {
      "a": "Psihološka procjena i psihodijagnostika",
      "b": "Primjena standardiziranih instrumenata i testova",
      "c": "Diferencijalna dijagnostika",
      "d": "Psihološki tretmani i psihoterapijski pristupi",
      "e": "Rana intervencija",
      "f": "Evaluacija učinkovitosti tretmana",
      "g": "Psihološki aspekti kroničnih bolesti i zdravstvenih ponašanja"
    }
  },
  {
    "title": "Psihologija u obrazovanju i razvoju karijere",
    "bullets": {
      "a": "Dobrobit učenika i studenata",
      "b": "Uloga psihologa u školi i predškolskim ustanovama",
      "c": "Uključivo obrazovanje i prilagodbe u učenju",
      "d": "Profesionalna orijentacija i razvoj karijere"
    }
  },
  {
    "title": "Rad, organizacije i specifični profesionalni sustavi",
    "bullets": {
      "a": "Psihološka dobrobit na radnom mjestu",
      "b": "Organizacijska kultura, vodstvo i otpornost",
      "c": "Digitalna transformacija i promjene rada",
      "d": "Ravnoteža privatnog i poslovnog života"
    }
  },
  {
    "title": "Zajednica, društveni kontekst i sustavi skrbi",
    "bullets": {
      "a": "Ovisnosti, nasilje i socijalni rizici",
      "b": "Penološka psihologija i psihologija u pravosudnom sustavu",
      "c": "Uloge psihologa u sustavima socijalne skrbi",
      "d": "Psihološki rizici, izvedba i dobrobit u sportskom okruženju",
      "e": "Inkluzija, participacija i kvaliteta života u zajednici",
      "f": "Javne politike i mentalno zdravlje"
    }
  },
  {
    "title": "Digitalno okruženje, mediji i suvremene tehnologije",
    "bullets": {
      "a": "Utjecaj digitalnih tehnologija na mentalno zdravlje",
      "b": "Videoigre i psihološka dobrobit",
      "c": "Društvene mreže i psihološka dobrobit",
      "d": "Umjetna inteligencija i psihološka praksa"
    }
  },
  {
    "title": "Raznolikost, identitet i ljudska prava",
    "bullets": {
      "a": "Seksualnost, rodni identitet i seksualne orijentacije",
      "b": "Psihologija i ljudska prava",
      "c": "Kulturalna osjetljivost i inkluzivna praksa",
      "d": "Tolerancija i prihvaćanje različitosti"
    }
  },
  {
    "title": "Profesionalni identitet, etika i razvoj struke",
    "bullets": {
      "a": "Etička pitanja u različitim područjima psihološke prakse",
      "b": "Granice kompetencija i interdisciplinarna suradnja",
      "c": "Supervizija i profesionalni razvoj",
      "d": "Etika u digitalnom svijetu: potencijali i rizici"
    }
  }
]

